import React, { FC } from 'react';
import { ImageDescription } from 'components/structures/general';
import { gridOptimization, gridOptimization2x } from 'images/us-energy-solutions';

const GridOptimization: FC = () => {
  return (
    <ImageDescription
      image={{
        image: gridOptimization,
        srcSet: `${gridOptimization} 516w, ${gridOptimization2x} 1032w`,
        imageCenterLg: true,
        disableMaxWidthLg: true,
        disableShadow: true,
      }}
      link={{ text: 'Give it a go', href: 'https://usenergysolutions.us/grid-optimization' }}
      title="Grid Optimization"
      text="US Energy Solutions is working hard to keep track of the changing needs of utilities and energy consumers by cultivating industry-leading grid optimization solutions. The company has the means necessary to optimize electricity grids, reduce harmful pollution, keep the lights on when severe weather strikes, and ensure that the customers are fully protected from any unpleasant surprises."
      align={'right'}
      gridItems={{ contentLg: 5, contentMd: 5, imageMd: 7, imageLg: 7 }}
    />
  );
};

export default GridOptimization;
